<template>
<div class="clientListVue">
  <!-- Main Body Content area -->
       <div class="o-main-content-area o-main-content-area--padBotoomNone">

           <!-- Heading Section -->
           <div class="row c-responsive-fixwidth">
               <div class="col-md-6">
                   <h1 class="h1">Clients</h1>
               </div>
               <div class="col-md-6 text-right">
                   <ul class="o-filter-area">

                       <li class="o-search-field">
                           <div class="input-group stylish-input-group">
                               <input type="text" class="form-control" placeholder="Client Search" v-model="search_query">
                               <span class="input-group-addon">
                                       <button type="submit">
                                           <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                               </button>
                               </span>
                           </div>
                       </li>
                       <li><a href="javascript: void(0)" @click="addClient()" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Client</a></li>
                       <li><a href="/soc2/" target="_blank" class="c-common-btn c-common-btn--blue" style="margin-left:10px;"><i class="fa fa-shield" aria-hidden="true"></i> SOC2 Dashboard</a></li>
                       <li>
                           <a href="javascript: void(0)"
                              @click="runSmsBilling()"
                              class="c-common-btn c-common-btn--blue"
                              :class="{'sms-billing-disabled': !isFirstOfMonth}"
                              style="margin-left:10px;">
                               <i class="fa fa-commenting" aria-hidden="true" v-if="!smsBillingLoading"></i>
                               <i class="fa fa-spinner fa-spin" aria-hidden="true" v-if="smsBillingLoading"></i>
                               Monthly SMS Billing
                           </a>
                       </li>
                       <li><a :href="adminToolsUrl" target="_blank" class="c-common-btn c-common-btn--blue" style="margin-left:10px;"><i class="fa fa-envelope" aria-hidden="true"></i> Email Admin</a></li>
                       <li><a href="javascript: void(0)" @click="openClaudeReports()" class="c-common-btn c-common-btn--blue" style="margin-left:10px;"><i class="fa fa-file-text" aria-hidden="true"></i> Claude Reports</a></li>
                       <!-- #1744 — payroll template workspace. SA-only surface; the
                            server-side gate is PayrollTemplateController's role check,
                            this button is only the entry point. -->
                       <li><a href="javascript: void(0)" @click="openTemplateWorkspace()" class="c-common-btn c-common-btn--blue" style="margin-left:10px;" data-testid="tpl-workspace-entry"><i class="fa fa-table" aria-hidden="true"></i> Payroll Templates</a></li>
                   </ul>
               </div>
           </div>
           <!-- /Heading Section -->

           <!-- list head -->
           <div class="c-common-space c-responsive-fixwidth">
               <div class="col-md-12 o-tab-area o-no-padding">
                   <ul class="o-tab-view o-tab-view--text">
                       <li><a href="javascript: void(0)" @click="changeStatus('active')" :class="{'active': status == 'active'}">Active</a></li>
                       <li><a href="javascript: void(0)" @click="changeStatus('inactive')" :class="{'active': status == 'inactive'}">Inactive</a></li>
                   </ul>
               </div>
           </div>
           <!-- /list head -->


       </div>
       <!-- /Main Body Content area -->

       <!-- Individual calls section area -->
       <div class="o-ndividualArea c-responsive-fixwidth">
          <activeClient :myProp="search_query" v-if = "status == 'active'"/>
          <inactiveClient :myProp="search_query" v-if = "status == 'inactive'"/>
       </div>

       <!-- SMS Billing Result Modal -->
       <div class="sms-billing-modal-overlay" v-if="smsBillingModalVisible" @click.self="">
           <div class="sms-billing-modal">
               <div class="sms-billing-modal-header">
                   <h3>Monthly SMS Billing Complete</h3>
                   <a href="javascript: void(0)" @click="smsBillingModalVisible = false" class="sms-billing-modal-close">&times;</a>
               </div>
               <div class="sms-billing-modal-body">
                   <p>Summary CSV is ready. Copy the link below:</p>
                   <div class="sms-billing-link-row">
                       <input type="text" class="form-control" :value="smsBillingSummaryUrl" readonly ref="smsBillingUrlInput" />
                       <a href="javascript: void(0)" @click="copySummaryUrl()" class="c-common-btn c-common-btn--green" style="margin-left:8px; white-space:nowrap;">
                           <i class="fa fa-clipboard"></i> Copy
                       </a>
                   </div>
                   <p v-if="smsBillingCopied" style="color:green; margin-top:8px;"><i class="fa fa-check"></i> Copied!</p>
               </div>
           </div>
       </div>
</div>

</template>
<script>
    import activeClient from './activeClient.vue';
    import inactiveClient from './inactiveClient.vue';
    import service from '../../services.js';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            'activeClient': activeClient,
            'inactiveClient' : inactiveClient
        },
        data() {
            return {
                'status': 'active',
                'search_query' : '',
                smsBillingLoading: false,
                smsBillingModalVisible: false,
                smsBillingSummaryUrl: '',
                smsBillingCopied: false,
                // Fallback — overwritten if DB provides a URL
                adminToolsUrl: 'https://apreports.callsteward.com/app/admintools/email-admin-powerusers-688d5a632cae5b3b956f99a3?embed=true',
            }
        },
        async created() {
            try {
                const res = await service.get('getAppsmithUrls', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                });
                const url = res && res.data && res.data.result && res.data.result.admin_tools_url;
                if (url) this.adminToolsUrl = url;
            } catch (e) {
                console.warn('[clientList] admin tools URL fallback:', e.message);
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            }),
            isFirstOfMonth() {
                return new Date().getDate() === 1;
            }
        },
        methods: {

            changeStatus(status) {
                this.status = status;
            },
            addClient() {
                this.$router.push({
                    'path': '/addClient'
                });
            },
            openTemplateWorkspace() { // #1744
                this.$router.push({ path: "/payrollTemplateWorkspace" }).catch(() => {});
            },
            openClaudeReports() {
                // Hand off the JWT on the URL for the first hit. The admin-reports
                // route validates, sets a short-lived httpOnly cookie scoped to
                // /admin-reports, and subsequent navigation inside the tab rides
                // that cookie — iframe links in the reports index work unmodified.
                const token = (this.userToken || '').replace(/^Bearer\s+/i, '');
                if (!token) return;
                window.open('/admin-reports/index.html?token=' + encodeURIComponent(token), '_blank');
            },
            runSmsBilling() {
                if (!this.isFirstOfMonth || this.smsBillingLoading) return;
                this.smsBillingLoading = true;
                this.smsBillingCopied = false;
                service.post('superadmin/smsBillingExport', {}, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.smsBillingLoading = false;
                    this.smsBillingSummaryUrl = res.data.summary_url || '';
                    this.smsBillingModalVisible = true;
                }).catch((err) => {
                    this.smsBillingLoading = false;
                    console.log(err);
                    this.$message.error('SMS Billing export failed. Check console for details.');
                });
            },
            copySummaryUrl() {
                this.$refs.smsBillingUrlInput.select();
                document.execCommand('copy');
                this.smsBillingCopied = true;
            },

        },
        mounted() {
            // Override viewport for mobile — clientList should be responsive,
            // not forced to width=1024 like the rest of the desktop app.
            const isSmallScreen = window.innerWidth <= 820 || /mobi|android|iphone|ipad|ipod|tablet/i.test(navigator.userAgent);
            if (isSmallScreen) {
                const meta = document.querySelector('meta[name="viewport"]');
                const content = 'width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no';
                if (meta) {
                    meta.setAttribute('content', content);
                } else {
                    const m = document.createElement('meta');
                    m.name = 'viewport';
                    m.content = content;
                    document.head.appendChild(m);
                }
            }
        }
    }

</script>
<style scoped>
/* @media (min-width: 1023px) and (min-width: 1500px){ */
        .margin-t-50{
            margin-top: 50px!important;
        }

        .c-radius3 {
            margin-top: 0 !important;
        }
    /* } */

    .sms-billing-disabled {
        opacity: 0.4;
        cursor: not-allowed !important;
        pointer-events: none;
    }

    .sms-billing-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sms-billing-modal {
        background: #fff;
        border-radius: 8px;
        width: 550px;
        max-width: 90%;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    }

    .sms-billing-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #e0e0e0;
    }

    .sms-billing-modal-header h3 {
        margin: 0;
        font-size: 18px;
    }

    .sms-billing-modal-close {
        font-size: 24px;
        color: #999;
        text-decoration: none;
        line-height: 1;
    }

    .sms-billing-modal-close:hover {
        color: #333;
    }

    .sms-billing-modal-body {
        padding: 20px;
    }

    .sms-billing-link-row {
        display: flex;
        align-items: center;
    }

    .sms-billing-link-row input {
        flex: 1;
    }

    /* ── Mobile responsive (Galaxy S6 = 360px) ── */
    @media (max-width: 820px) {
        .clientListVue >>> .o-main-content-area {
            padding: 10px 5px !important;
        }
        .clientListVue >>> .c-responsive-fixwidth {
            width: 100% !important;
            padding: 0 5px;
        }
        .clientListVue >>> .row .col-md-6 {
            width: 100%;
            float: none;
            text-align: left !important;
        }
        .clientListVue >>> .row .col-md-6 h1 {
            font-size: 20px;
            margin: 5px 0;
        }
        .clientListVue >>> .o-filter-area {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            padding: 0;
            margin: 5px 0;
        }
        .clientListVue >>> .o-filter-area li {
            margin: 0;
        }
        .clientListVue >>> .o-filter-area .o-search-field {
            width: 100%;
        }
        .clientListVue >>> .o-filter-area .o-search-field .input-group {
            width: 100%;
        }
        .clientListVue >>> .o-filter-area .c-common-btn {
            font-size: 12px;
            padding: 6px 10px;
        }
        .clientListVue >>> .o-tab-view {
            display: flex;
            gap: 0;
        }
        .clientListVue >>> .o-tab-view li {
            flex: 1;
            text-align: center;
        }
    }
</style>
